export default __webpack_public_path__ + "static/media/Eina02-Light.96235290.ttf";